(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[300],{

/***/ 5492:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/parents-and-teachers",
      function () {
        return __webpack_require__(8978);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _src_components_background__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5874);
/* harmony import */ var _src_components_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5962);
/* harmony import */ var _public_images_credit_bg_jpg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2133);
/* harmony import */ var _teachers_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(722);
/* harmony import */ var _teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _src_components_popup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9255);
/* harmony import */ var _src_components_arrowButton__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1469);
/* harmony import */ var _src_components_actions_default_click__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7869);
/* harmony import */ var _src_components_actions_default_hover__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9148);
/* harmony import */ var _src_components_icons_question__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7350);












function index(param) {
    var dataAudio = param.dataAudio;
    var _this = this;
    var ref, ref1, ref2, ref3, ref4;
    var bgData = {
        bgImage: _public_images_credit_bg_jpg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z
    };
    var pageData = {
        title: "להורים ומורים",
        content: "<p>התערוכה בנויה לביקור אישי של ילד, או קבוצה קטנה של ילדים מול מחשב אישי.</p><p>אם הצפייה היא במסגרת ביתית, אנו ממליצים לכם כהורים לחוות את התערוכה בעצמכם, לפני או יחד עם ילדכם. אם ילדכם עדיין אינו בן שתים עשרה, נוכחותכם יחד איתו חשובה עוד יותר.</p><p>אם הסיור מתקיים במסגרת כתתית, מומלץ מאד למחנכת הכיתה לחוות את כל התערוכה באופן אישי לפני המסירה לתלמידים.</p>",
        popButton1: {
            text: "סיור פרטני בתערוכה",
            type: "2",
            popup: "popup1"
        },
        popButton2: {
            text: "הצעה לסיור כתתי בתערוכה",
            type: "2",
            popup: "popup2"
        },
        pageButton: {
            color: "#223A57",
            text: "אודות הפרויקט"
        }
    };
    var popupData = {
        popup1: {
            title: "סיור פרטני בתערוכה",
            content: "<p>התערוכה בנויה לביקור אישי של ילד או קבוצה קטנה של ילדים מול מחשב אישי.</p><p>מערכת שמע: התערוכה מלווה בקרינות, במוזיקה ובאפקטים קוליים. בכדי לחוות את סרטון הפתיחה, וכן את סיפוריהם של פודי הילדים בפרק 3, יש צורך במערכת שמע ולהפעיל את הרמקול או להעזר באזניות.</p><p>עדויות: בכל חלק בתערוכה קיימים לחצני עדויות, המסומנים באייקון של ציטוט. בלחיצה על האייקון יפתח קטע קצר של עדות מוסרטת של ילד מסתור מתוך מאגר העדויות של גנזך קידוש השם. בנוסף, מובא סיפורו המקוצר של העד, כדי לספק לצופים השלמה של הסיפור.</p><p>שאלות: גם לחצני שאלות מסומנים באייקון של סימן שאלה. השאלות והתשובות הנפתחות בלחיצה ומספקות חומר רקע היסטורי, ופרטים נוספים על עולמם של ילדי המסתור, ומאפשרים למבקרים להעמיק בנושאים המעניינים אותם.</p><p>הצפייה בעדויות ובשאלות אינה חובה, וביכולתו של המבקר להאריך או לקצר בה לפי הסבלנות ומידת העניין שלו. מומלץ מאד לאפשר לילד לחוות בעצמו את חווית העניין, החקירה והלמידה, בהתאמה לסקרנותו, יכולותיו וצרכיו. האורך המשוער של כל אחד מהפרקים הוא כעשרים דקות, כולל צפיה בכל העדויות. ניתן לעבור ולנווט בין פרק לפרק באמצעות תפריט הניווט המוצג בצד ימין של המסך.</p>",
            type: "info",
            id: 1
        },
        popup2: {
            title: "הצעה לסיור כתתי בתערוכה",
            content: "<p>מומלץ מאד למורה הכיתה לחוות את כל התערוכה באופן אישי לפני המסירה לתלמידים.</p><p>ההמלצה לסיור כיתתי היא להקצות מחשב אחד לכל קבוצה של עד שלושה תלמידים. באופן הזה, הכיתה תפתח בצפייה משותפת בסרטון, ובדברי הדרכה של המורה. לאחר מכן כל קבוצה תחקור באופן עצמאי את התערוכה במשך כשעה עד שעה ורבע.</p><p>הכיתה תחזור לדיון קבוצתי על אחד או יותר מהנושאים הבאים:</p><ul><li>אהבת ההורים והמסירות המתגלה דווקא בפרידה</li><li>מקורות כח של הילדים בזמן המסתור</li><li>זהות עצמית מול סביבה זרה או עויינת</li><li>המניעים של פודי הילדים להקדשת זמן ומאמצים לפדיון ילדים זרים</li><li>תהליכים של שיקום לאחר קושי</li><li>השוואה בין תחושת הבגידה והנטישה של הילדים בזמן אמת, ובין המבט הבוגר המבין שכל הצדדים פעלו מתוך אהבה.</li><li>גבורה וביטוייה בזמן השואה</li></ul><p>ניתן גם לפצל את התערוכה לארבעה שיעורים, בכל שיעור יוקדש פרק אחד ללמידה צפייה ודיון.  (לקריאה נוספת על החלוקה של ארבעת הפרקים חיזרו לעמוד ‘אודות הפרויקט’ שם מפורט כל פרק ותוכנו)</p>",
            type: "info",
            id: 2
        }
    };
    // Popup Function
    var openPopup = function(ID, element) {
        //console.log(element);
        var popup = document.getElementById(ID);
        if (popup.classList.contains("active")) {
            popup.classList.remove("active");
        } else {
            popup.classList.add("active");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_src_components_layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        header: "show",
        footer: "hide",
        audio: dataAudio,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: "noindex"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "vertical-wrapper relative h-screen w-screen z-10 overflow-hidden flex flex-nowrap flex-row-reverse ".concat((_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().container)),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_background__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        data: bgData,
                        moveBG: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "v-section w-screen h-auto z-50 flex content-center justify-center ".concat((_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().wrapper)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat((_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().content)),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        children: pageData.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "".concat((_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().text)),
                                        dangerouslySetInnerHTML: {
                                            __html: pageData.content
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "".concat((_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().buttonsGroup)),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex justify-start w-full ".concat((_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().magnetic)),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                    onClick: function() {
                                                        var ref;
                                                        openPopup(pageData === null || pageData === void 0 ? void 0 : (ref = pageData.popButton1) === null || ref === void 0 ? void 0 : ref.popup, _this);
                                                        (0,_src_components_actions_default_click__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
                                                    },
                                                    onMouseEnter: function() {
                                                        (0,_src_components_actions_default_hover__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
                                                    },
                                                    className: "poplink flex items-center flex-row-reverse ".concat((_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().buttonInfo)),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: (_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().iconText),
                                                            children: pageData === null || pageData === void 0 ? void 0 : (ref = pageData.popButton1) === null || ref === void 0 ? void 0 : ref.text
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "flex items-center justify-center ".concat((_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon)),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: (_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().after)
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_icons_question__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "flex justify-start w-full ".concat((_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().magnetic)),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                    onClick: function() {
                                                        var ref;
                                                        openPopup(pageData === null || pageData === void 0 ? void 0 : (ref = pageData.popButton2) === null || ref === void 0 ? void 0 : ref.popup, _this);
                                                        (0,_src_components_actions_default_click__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
                                                    },
                                                    onMouseEnter: function() {
                                                        (0,_src_components_actions_default_hover__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
                                                    },
                                                    className: "poplink flex items-center flex-row-reverse ".concat((_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().buttonInfo)),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: (_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().iconText),
                                                            children: pageData === null || pageData === void 0 ? void 0 : (ref1 = pageData.popButton2) === null || ref1 === void 0 ? void 0 : ref1.text
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "flex items-center justify-center ".concat((_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon)),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: (_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().after)
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_icons_question__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute direction-rtl z-50 ".concat((_teachers_module_scss__WEBPACK_IMPORTED_MODULE_11___default().button)),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_arrowButton__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    onClick: function() {
                                        (0,_src_components_actions_default_click__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
                                    },
                                    onMouseEnter: function() {
                                        (0,_src_components_actions_default_hover__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
                                    },
                                    className: "p-5",
                                    link: "/about/",
                                    color: pageData === null || pageData === void 0 ? void 0 : (ref2 = pageData.pageButton) === null || ref2 === void 0 ? void 0 : ref2.color,
                                    textColor: pageData === null || pageData === void 0 ? void 0 : (ref3 = pageData.pageButton) === null || ref3 === void 0 ? void 0 : ref3.color,
                                    text: pageData === null || pageData === void 0 ? void 0 : (ref4 = pageData.pageButton) === null || ref4 === void 0 ? void 0 : ref4.text
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_popup__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                popupID: "popup1",
                data: popupData.popup1
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_popup__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                popupID: "popup2",
                data: popupData.popup2
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),

/***/ 5874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(458);
/* harmony import */ var gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _background_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7820);
/* harmony import */ var _background_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_background_module_scss__WEBPACK_IMPORTED_MODULE_4__);





function BackgroundImage(param) {
    var data = param.data, moveBG = param.moveBG, classes = param.classes, bgcolor = param.bgcolor, position = param.position;
    var ref, ref1, ref2, ref3;
    // Animations
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.set(".section-bg", {
            scale: 1.4,
            opacity: 0
        });
        if (moveBG !== "no") {
            gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.to(".section-bg", {
                scale: 1.2,
                opacity: 1,
                ease: "power.out",
                duration: 1,
                delay: 0
            });
        } else {
            gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.to(".section-bg", {
                scale: 1,
                opacity: 1,
                ease: "power.out",
                duration: 1,
                delay: 0
            });
        }
        // Background Animation
        //console.log(moveBG);
        if (moveBG !== "no") {
            var parallaxIt = function parallaxIt(e, target, movement) {
                var relX = e.pageX - container.offsetLeft;
                var relY = e.pageY - container.offsetTop;
                gsap_dist_gsap__WEBPACK_IMPORTED_MODULE_3__.gsap.to(target, 1, {
                    x: (relX - container.offsetWidth / 2) / container.offsetWidth * movement,
                    y: (relY - container.offsetHeight / 2) / container.offsetHeight * movement
                });
            };
            var container = document.querySelector(".body");
            container.addEventListener("mousemove", function(e) {
                parallaxIt(e, ".section-bg", -30);
            //parallaxIt(e, ".bg-mask1", -50);
            });
        }
    }, [
        moveBG
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                backgroundColor: bgcolor
            },
            className: "section-bg ".concat((_background_module_scss__WEBPACK_IMPORTED_MODULE_4___default().sectionBG), " ").concat(position !== "fixed" ? "absolute" : "fixed", " left-0 top-0 w-screen h-screen z-10 ").concat(classes),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                className: "block object-cover object-center w-full h-full",
                src: data === null || data === void 0 ? void 0 : (ref = data.bgImage) === null || ref === void 0 ? void 0 : ref.src,
                height: data === null || data === void 0 ? void 0 : (ref1 = data.bgImage) === null || ref1 === void 0 ? void 0 : ref1.height,
                width: data === null || data === void 0 ? void 0 : (ref2 = data.bgImage) === null || ref2 === void 0 ? void 0 : ref2.width,
                blurDataURL: data === null || data === void 0 ? void 0 : (ref3 = data.bgImage) === null || ref3 === void 0 ? void 0 : ref3.blurDataURL,
                placeholder: "blur",
                alt: "Section BG"
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (BackgroundImage);


/***/ }),

/***/ 722:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"teachers_container__Y2dsC","wrapper":"teachers_wrapper__8os6v","content":"teachers_content__pP7EK","text":"teachers_text__t0nxt","buttonsGroup":"teachers_buttonsGroup__xGGQb","magnetic":"teachers_magnetic__6isel","buttonInfo":"teachers_buttonInfo__ezz6T","icon":"teachers_icon__yLoqn","after":"teachers_after__Gzzkz","button":"teachers_button__r1pvH"};

/***/ }),

/***/ 7820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionBG":"background_sectionBG__8doep"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [362,428,962,680,45,774,888,179], function() { return __webpack_exec__(5492); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);